/* MedMerch theme — theme.js (no dependencies) */
(function () {
  'use strict';
  var root = document.documentElement;
  root.classList.add('js');

  /* ---------- Navigation (hamburger) ---------- */
  var toggle = document.querySelector('[data-nav-toggle]');
  var scrim = document.querySelector('[data-nav-scrim]');
  var nav = document.getElementById('site-nav');

  function setNav(open) {
    if (!toggle) return;
    document.body.classList.toggle('nav-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.setAttribute('aria-label', open ? toggle.dataset.labelClose : toggle.dataset.labelOpen);
    if (nav) nav.setAttribute('aria-hidden', open ? 'false' : 'true');
  }
  if (toggle) {
    toggle.addEventListener('click', function () {
      setNav(toggle.getAttribute('aria-expanded') !== 'true');
    });
    if (scrim) scrim.addEventListener('click', function () { setNav(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        setNav(false);
        toggle.focus();
      }
    });
    if (nav) nav.addEventListener('click', function (e) {
      if (e.target.closest('a')) setNav(false);
    });
  }

  /* ---------- Cart count ---------- */
  var countEl = document.querySelector('[data-cart-count]');
  var showZero = countEl && countEl.dataset.showZero === 'true';

  function setCount(n) {
    if (!countEl) return;
    countEl.textContent = n;
    countEl.hidden = !(n > 0 || showZero);
    countEl.setAttribute('aria-label', n + ' ' + (n === 1 ? countEl.dataset.labelOne : countEl.dataset.labelMany));
    countEl.classList.remove('is-bumped');
    void countEl.offsetWidth;
    countEl.classList.add('is-bumped');
  }

  function refreshCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCount(cart.item_count); return cart; });
  }

  function goCheckout() {
    // the preview listens for this event; on a real store it falls through to /checkout
    var ev = new CustomEvent('mm:checkout', { cancelable: true });
    if (document.dispatchEvent(ev)) window.location.href = '/checkout';
  }

  /* ---------- Product form: variants + AJAX add to bag ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var dataEl = form.parentElement.querySelector('[data-product-json]') || document.querySelector('[data-product-json]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { /* no variants json */ }
    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-product-price]');
    var addBtn = form.querySelector('[data-add-to-cart]');
    var statBtn = form.querySelector('[data-stat-order]');
    var errorEl = form.querySelector('[data-form-error]');
    var lang = {
      add: addBtn ? addBtn.dataset.labelAdd : '',
      added: addBtn ? addBtn.dataset.labelAdded : '',
      soldOut: addBtn ? addBtn.dataset.labelSoldout : ''
    };

    function selectedValues() {
      var vals = [];
      form.querySelectorAll('.option').forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        vals.push(c ? c.value : null);
      });
      return vals;
    }

    function currentVariant() {
      var vals = selectedValues();
      return variants.find(function (v) {
        return vals.every(function (val, i) { return val === null || v.options[i] === val; });
      });
    }

    function onOptionChange() {
      var v = currentVariant();
      form.querySelectorAll('[data-selected-value]').forEach(function (el) {
        var fs = el.closest('.option');
        var c = fs && fs.querySelector('input:checked');
        el.textContent = c ? c.value : '';
      });
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = lang.soldOut; }
        if (statBtn) statBtn.disabled = true;
        return;
      }
      idInput.value = v.id;
      if (priceEl && v.price_formatted) priceEl.innerHTML = v.price_formatted + (v.compare_formatted ? ' <s>' + v.compare_formatted + '</s>' : '');
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? lang.add : lang.soldOut;
      }
      if (statBtn) statBtn.disabled = !v.available;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* ignore */ }
      // Lets Shopify's dynamic checkout (Apple Pay / Shop Pay / Google Pay) pick up the new variant
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    form.querySelectorAll('.option input').forEach(function (i) { i.addEventListener('change', onOptionChange); });

    // STAT Order: add this item, then go straight to checkout (Apple Pay is offered there on supported devices)
    if (statBtn) statBtn.addEventListener('click', function () {
      if (statBtn.disabled) return;
      statBtn.disabled = true;
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.json.description || res.json.message || 'Error');
          return refreshCount();
        })
        .then(function () { goCheckout(); })
        .catch(function (err) {
          if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
          statBtn.disabled = false;
        });
    });

    form.addEventListener('submit', function (e) {
      // Only the "Add to Bag" button is AJAX; the dynamic checkout buttons keep their native behaviour.
      if (!e.submitter || !e.submitter.hasAttribute('data-add-to-cart')) return;
      e.preventDefault();
      if (addBtn.disabled) return;
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
      addBtn.disabled = true;

      var body = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: body, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.json.description || res.json.message || 'Error');
          addBtn.textContent = lang.added;
          addBtn.classList.add('is-added');
          return refreshCount();
        })
        .catch(function (err) {
          if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
        })
        .then(function () {
          setTimeout(function () {
            addBtn.classList.remove('is-added');
            addBtn.disabled = false;
            addBtn.textContent = lang.add;
          }, 1800);
        });
    });
  });

  /* ---------- Cart page: Prior Auth Code ---------- */
  document.querySelectorAll('[data-prior-auth]').forEach(function (box) {
    var input = box.querySelector('[data-prior-auth-input]');
    var btn = box.querySelector('[data-prior-auth-apply]');
    function apply() {
      var code = (input.value || '').trim();
      if (!code) { input.focus(); return; }
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart');
    }
    btn.addEventListener('click', apply);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); apply(); } });
  });

  /* ---------- Cart page: quantity steppers ---------- */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var form = wrap.closest('form');
    wrap.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-step]');
      if (!b) return;
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(b.dataset.step, 10));
      input.value = next;
      form.submit();
    });
    input.addEventListener('change', function () { form.submit(); });
  });

  /* ---------- Scroll reveal ---------- */
  var items = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && items.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { io.observe(el); });
  } else {
    items.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- Home-page intro animation ----------
     Only runs when the page contains [data-intro] (the "Intro animation" section on the home page).
     Sequence: "Evidence based medicine" + big Rx  →  word rolls to "merchandise"  →  text rolls away,
     "MedMerch" rolls in and the Rx shrinks up beside it  →  on scroll the lockup shrinks into the header.
     Final lockup proportions come from the Header section sliders. */
  var intro = null;

  function num(v, d) { var n = parseFloat(v); return isNaN(n) ? d : n; }

  function initIntro() {
    if (intro) { intro.destroy(); intro = null; }
    var stage = document.querySelector('[data-intro]');
    var header = document.querySelector('.site-header');
    var brand = header && header.querySelector('.brand');
    var mark = brand && brand.querySelector('.brand__mark');
    var wordmask = brand && brand.querySelector('.brand__wordmask');

    function cleanup() {
      ['has-intro', 'intro-booting', 'intro-hold', 'intro-p3', 'intro-instant'].forEach(function (c) { root.classList.remove(c); });
      root.style.removeProperty('--intro-dur');
      if (brand) {
        brand.style.transform = '';
        ['--ilx', '--ily', '--ilk'].forEach(function (k) { brand.style.removeProperty(k); });
      }
      if (header) header.classList.remove('is-docked');
    }

    if (!stage || stage.offsetParent === null || !brand || !mark || !wordmask) { cleanup(); return; }

    cleanup();
    root.classList.add('has-intro', 'intro-booting');

    var cfg = {
      pause1: num(stage.dataset.pause1, 1), swap: num(stage.dataset.swap, 0.5), pause2: num(stage.dataset.pause2, 0.9),
      fin: num(stage.dataset.final, 0.8), boost: num(stage.dataset.boost, 1.8), scale: num(stage.dataset.scale, 3.2),
      phrasePct: num(stage.dataset.phrasePct, 100) / 100, once: stage.dataset.once === 'true',
      pad: num(stage.dataset.pad, 0), lineGap: num(stage.dataset.lineGap, 6),
      autoDock: stage.dataset.autoDock !== 'false', dockHold: num(stage.dataset.dockHold, 0.4), dockSpeed: num(stage.dataset.dockSpeed, 0.9)
    };
    var band = stage.querySelector('[data-band]');
    var line = stage.querySelector('[data-line]');
    var staticEl = stage.querySelector('[data-static]');
    var roll = stage.querySelector('[data-roll]');
    var rollIn = stage.querySelector('[data-roll-in]');
    var w1El = stage.querySelector('[data-w1]');
    var w2El = stage.querySelector('[data-w2]');

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var design = !!(window.Shopify && window.Shopify.designMode);
    var seen = false;
    try { seen = cfg.once && !design && sessionStorage.getItem('mm_intro_seen') === '1'; } catch (e) { /* ignore */ }
    try { sessionStorage.setItem('mm_intro_seen', '1'); } catch (e) { /* ignore */ }
    var play = !reduce && !seen && window.scrollY < 20;

    var timers = [];
    var second = false;
    var m = { S: 1, C0y: 0, Hy: 0, w1: 0, w2: 0, fullH: 0 };
    var collapse = 0;          // 0 = box full height, 1 = box gone (header is the lockup)
    var dockRaf = 0, dockTimer = 0, dockStart = 0, docking = false, selfScroll = false;

    function layout() {
      brand.style.transform = 'none';
      var vw = root.clientWidth;
      var bw = brand.offsetWidth, bh = brand.offsetHeight;
      var wordPx = parseFloat(getComputedStyle(brand).fontSize);
      var logoH = mark.offsetHeight, logoW = mark.offsetWidth;
      var S = Math.max(1, Math.min(cfg.scale, (vw * 0.8) / bw));
      var wy = (wordmask.offsetTop + wordmask.offsetHeight / 2) - bh / 2;
      var r = brand.getBoundingClientRect();
      var Hy = r.top + r.height / 2;

      // fit the phrase on one line
      roll.style.width = '';
      line.style.fontSize = '100px';
      var sw = staticEl.getBoundingClientRect().width;
      var ww1 = w1El.getBoundingClientRect().width;
      var ww2 = w2El.getBoundingClientRect().width;
      var total100 = sw + 28 + Math.max(ww1, ww2);
      var fit = (vw * 0.92) / (total100 / 100);
      var pf = Math.min(S * wordPx * cfg.phrasePct, fit);
      line.style.fontSize = pf + 'px';
      var f = pf / 100;
      m.w1 = ww1 * f + pf * 0.1; m.w2 = ww2 * f + pf * 0.1;
      roll.style.width = (second ? m.w2 : m.w1) + 'px';

      // stage geometry (document coordinates; the animation always starts at scroll 0).
      // The box is exactly as tall as its content: phrase band + gap + big logo + padding.
      var bandH = pf * 1.0;
      var gap = cfg.lineGap;
      var bigVis = cfg.boost * S * logoH;
      var fullH = cfg.pad + bandH + gap + bigVis + cfg.pad;
      m.fullH = fullH;
      stage.style.height = (fullH * (1 - collapse)) + 'px';
      var sr = stage.getBoundingClientRect();
      var docTop = sr.top + window.scrollY;
      var Yb = docTop + cfg.pad + bandH / 2;
      band.style.height = bandH + 'px';
      band.style.top = cfg.pad + 'px';
      var C0y = Yb - S * wy;

      // big starting logo, centred under the phrase
      var ilk = cfg.boost;
      var lcx = mark.offsetLeft + logoW / 2, lcy = mark.offsetTop + logoH / 2;
      var ilx = bw / 2 - lcx;
      var yL = Yb + bandH / 2 + gap + bigVis / 2;
      var ily = (yL - C0y) / S - (lcy - bh / 2);
      brand.style.setProperty('--ilx', ilx + 'px');
      brand.style.setProperty('--ily', ily + 'px');
      brand.style.setProperty('--ilk', ilk);
      m.S = S; m.C0y = C0y; m.Hy = Hy;
    }

    function applyScroll() {
      var dist = m.C0y - m.Hy;
      var y = window.scrollY;
      var ps = dist > 1 ? Math.min(1, Math.max(0, y / dist)) : 1;
      var p = Math.max(ps, collapse);
      var s = m.S + (1 - m.S) * p;
      brand.style.transform = 'translateY(' + (dist * (1 - p)) + 'px) scale(' + s + ')';
      header.classList.toggle('is-docked', p >= 0.7);
    }

    function setCollapse(q) {
      var before = stage.offsetHeight;
      collapse = q;
      stage.style.height = (m.fullH * (1 - q)) + 'px';
      stage.classList.toggle('is-gone', q >= 1);
      // The box shrinks, so everything below it moves up. If the visitor has already scrolled,
      // scroll up by the same amount so the part of the page they are looking at stays put.
      var delta = before - stage.offsetHeight;
      var y = window.scrollY;
      if (delta > 0 && y > 0) {
        selfScroll = true;
        window.scrollTo({ top: Math.max(0, y - delta), left: 0, behavior: 'instant' });
        requestAnimationFrame(function () { selfScroll = false; });
      }
      applyScroll();
    }
    function cancelDock() {
      if (dockRaf) cancelAnimationFrame(dockRaf);
      clearTimeout(dockTimer);
      dockRaf = 0; dockTimer = 0;
    }
    // Shrinks the box away and docks MedMerchRx into the header. Runs even if the visitor scrolled
    // early, so the lockup can never get stuck large.
    function startDock(waitSeconds) {
      if (docking || collapse >= 1) return;
      docking = true;
      var wait = (waitSeconds === undefined ? cfg.dockHold : waitSeconds) * 1000;
      dockTimer = setTimeout(function () {
        dockStart = performance.now();
        var dur = Math.max(100, cfg.dockSpeed * 1000);
        (function step(now) {
          var t = Math.min(1, (now - dockStart) / dur);
          var e = t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; // ease in-out
          setCollapse(e);
          if (t < 1) dockRaf = requestAnimationFrame(step); else dockRaf = 0;
        })(dockStart);
      }, wait);
    }

    function phase2() {
      second = true;
      roll.style.width = m.w2 + 'px';
      rollIn.classList.add('is-2');
    }
    function phase3(fast) {
      root.classList.remove('intro-hold');
      root.classList.add('intro-p3');
      // "fast" = the visitor scrolled early: skip the hold and finish docking right away
      if (cfg.autoDock) timers.push(setTimeout(function () { startDock(fast ? 0.05 : undefined); }, (fast ? 0.35 : cfg.fin) * 1000));
    }
    function clearTimers() { timers.forEach(clearTimeout); timers = []; }
    function finish() {
      if (!root.classList.contains('intro-hold')) return;
      clearTimers();
      second = true;
      rollIn.classList.add('is-2');
      roll.style.width = m.w2 + 'px';
      root.style.setProperty('--intro-dur', '0.35s');
      phase3(true);
    }

    var ticking = false;
    function onScroll() {
      if (selfScroll) return;
      if (window.scrollY > 4) finish();
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(function () { ticking = false; applyScroll(); });
      }
    }
    function onResize() { layout(); applyScroll(); }
    function onToggle() { finish(); }

    root.classList.add('intro-instant');
    if (play) root.classList.add('intro-hold');
    else root.classList.add('intro-p3');
    if (!play) { second = true; rollIn.classList.add('is-2'); }

    layout();
    // Not playing the animation at the top of the page (reduced motion / already seen):
    // no box at all, the header is the lockup straight away.
    if (!play && cfg.autoDock && window.scrollY < 20) setCollapse(1);
    else if (!play && cfg.autoDock) startDock(0.15);   // page opened already scrolled down
    applyScroll();
    requestAnimationFrame(function () {
      root.classList.remove('intro-booting');
      requestAnimationFrame(function () { root.classList.remove('intro-instant'); });
    });

    if (play) {
      var t = cfg.pause1 * 1000;
      timers.push(setTimeout(phase2, t));
      t += (cfg.swap + cfg.pause2) * 1000;
      timers.push(setTimeout(phase3, t));
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    if (toggle) toggle.addEventListener('click', onToggle);

    intro = {
      finish: finish,
      destroy: function () {
        clearTimers(); cancelDock();
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onResize);
        if (toggle) toggle.removeEventListener('click', onToggle);
      }
    };
  }

  function bootIntro() {
    var ready = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
    ready.then(initIntro, initIntro);
  }
  window.mmInitIntro = initIntro;
  bootIntro();
  document.addEventListener('shopify:section:load', function () { initIntro(); });
  document.addEventListener('shopify:section:unload', function () { setTimeout(initIntro, 0); });

  // Keep the badge right after back/forward cache restores
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCount(); });
})();
